<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>
              {{ source.name }}
            </h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Name *</label>
                  <div class="col-md-10">
                    <input
                      id="name"
                      v-model="entity.name"
                      type="text"
                      placeholder="Enter name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Permissions</label>
                  <div v-if="defaultOptionsLoaders.permissions" class="col-md-10 spinner-parent">
                    <spinner ref="spinner" size="md" text="Loading ..." style="display: block;" />
                  </div>
                  <div v-else class="col-md-10" style="column-count: 3;">
                    <div v-for="permission in defaultOptions.permissions" :key="permission.id">
                      <label>
                        <input
                          :id="permission.id"
                          v-model="entity.permissions"
                          type="checkbox"
                          :value="permission"
                        > {{ permission.name }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="saveEntity">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Data saved successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';

export default {
  name: 'RolesEdit',

  mixins: [EditPageMixin, DefaultOptionsRequests],

  data() {
    return {
      source: null,
      entity: {},
    };
  },

  mounted() {
    this.$_getDefaultPermissions();
  },

  methods: {
    isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      return true;
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}roles/${this.$route.params.id}?with[]=permissions`)
        .then((response) => {
          this.source = response.data;
          this.entity = _.cloneDeep(response.data);
          if (!Object.prototype.hasOwnProperty.call(response.data, 'avatar')) {
            this.source.avatar = null;
            this.entity.avatar = null;
          }
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        }).catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting data request' });
          console.error(error);
        });
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      if (this.entity.permissions && this.entity.permissions.length) {
        for (let i = 0; i < this.entity.permissions.length; i += 1) {
          postFormData.append('permissions[]', this.entity.permissions[i].id);
        }
      }
      return this.$apiHttp.post(`${this.$config.app_api.prefix}roles/${this.$route.params.id}`, postFormData);
    },
    saveEntity() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(() => {
        this.$_successSave();
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in update user query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?02331f4f